import React from 'react';
import LabelWrap from 'components/inputs/LabelWrap';
import AutoSizedTextArea from 'components/inputs/AutoSizedTextArea';
import styled from 'styled-components';

const Bold = styled.div`
  font-weight: 500;
`;

type OverrideDrivingPolicyInputProps = {
  extraInfo: string;
  setExtraInfo: (value: string) => void;
};

const OverrideDrivingPolicyInput = ({
  extraInfo,
  setExtraInfo,
}: OverrideDrivingPolicyInputProps) => (
  <LabelWrap label={<Bold>Meddelande:</Bold>}>
    <AutoSizedTextArea
      onChange={(e) => setExtraInfo(e.currentTarget.value)}
      placeholder="Lägg in eventuell information till föraren här"
      value={extraInfo}
    />
  </LabelWrap>
);

export default OverrideDrivingPolicyInput;
